<script setup lang="ts">
  import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'

  import { ref, onMounted } from 'vue'

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  const fileName = ref<string>('BirdID-Sign-Plugin')

  if (navigator.userAgent.indexOf('Win') !== -1) {
    fileName.value += '.exe'
  }

  if (navigator.userAgent.indexOf('Mac') !== -1) {
    fileName.value += '.dmg'
  }

  const emit = defineEmits(['retry'])

  onMounted(() => {
    modal.value = new Modal('#modal-plugin-confirmation', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function callAction() {
    emit('retry')
    hide()
  }

  defineExpose({ show, hide })
</script>

<template>
  <div id="modal-plugin-confirmation" class="modal modal-md fade" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header"></div>
        <div class="modal-body py-3">
          <h5 class="modal-title mb-5">Execute o plugin em seu computador</h5>
          <img alt="sucesso" src="../../../assets/images/download.gif" />

          <p class="fs-6 text-start mt-4">
            O plugin é essencial para a emissão do seu Certificado Digital A1.
          </p>

          <p class="fs-6 text-start mt-4">
            <strong>Siga os passos abaixo para executar o arquivo:</strong>
          </p>

          <div class="d-flex gap-2 align-items-start">
            <icon-component class="green pt-1" name="circle-check" />
            <p class="fs-6 text-start">
              Baixe o plugin, <strong>“{{ fileName }}”</strong>, em seu
              computador.
            </p>
          </div>

          <div class="d-flex gap-2 align-items-start">
            <icon-component class="green pt-1" name="circle-check" />
            <p class="fs-6 text-start">
              Na pasta de downloads,
              <strong
                >identifique o arquivo e clique duas vezes para abrir.</strong
              >
              Ou, com o botão direito do mouse, clique no arquivo e, em seguida,
              selecione "Abrir".
            </p>
          </div>

          <div class="d-flex gap-2 align-items-start mb-4">
            <icon-component class="green pt-1" name="circle-check" />
            <p class="fs-6 text-start">
              <strong>Pronto!</strong> Clique no botão abaixo para prosseguir
              com a instalação do seu Certificado Digital.
            </p>
          </div>

          <a
            href="../faq/digital-certificate-plugin"
            target="_blank"
            rel="noopener noreferrer"
            class="link"
          >
            <span class="me-2">Instruções para executar o plugin</span>
            <icon-component name="up-right-from-square" />
          </a>
        </div>
        <div class="modal-footer py-3">
          <button class="btn btn-primary" type="button" @click="callAction">
            Tudo certo, avançar
            <icon-component name="arrow-right" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .modal-title {
    font-size: 1.5rem;
    font-weight: 500;
    color: #2f3242;
  }

  .green {
    color: #98dd63;
  }

  .link {
    font-size: 1rem;
    font-weight: 400;
    color: #0080a3;
    cursor: pointer;
  }

  .link:hover {
    text-decoration: underline;
  }

  @media (min-width: 576px) {
    .modal-md {
      --bs-modal-width: 624px;
    }
  }
</style>
